import './hireSelectAccount.scss';

// @vendor
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const filterLodash = require('lodash/collection/filter');

// @components
import DropdownAccounts from 'components/dropdownAccounts/dropdownAccounts';
import { ContractDisclaimerPersonalInfo } from 'routes/contractsView/components/ContractDisclaimerPersonalInfo/ContractDisclaimerPersonalInfo';
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';
// import MaskedAmount from 'components/maskedAmount/maskedAmount';
import OKSelect from 'components/commons/OKSelect/OKSelect';
import { NGOModalSearcher } from 'components/ngoModalSearcher/ngoModalSearcher';

// @common-components
import { OKAutosuggest } from 'commonsComponents/OKAutosuggest';

// @actions
import { setWizardButtonStateByButton, addStep, setAllAccountsToInactive, setNgoSelected, setAssociateAccountSelected } from 'actions/okWizard';

// @helpers
const { getNotSelectedFoundations } = require('utilities/NGOHelper');
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;
import { getCurrentAccounts } from 'utilities/currentAccountsHelper';
import { getFormattedString } from 'utilities/currencyHelper';
import apiURLBuilder from 'core/apiURLBuilder';
const {
    recordLink,
    PROC_ONG_SEARCHER,
    recordPage,
    PROC_ONG_RESULT_CLICK
} = require('utilities/tagging');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @api
import { APIGet } from 'utilities/APIRequestHelper';

// @constants
import {
    LIMIT_CHARITY_AMOUNT,
    CHECKING_ACCOUNT_CODE,
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    EURO_TEXT,
    NGO_MODAL_CARD
} from 'constants/index';
import { ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES } from 'constants/accounts';
const { analyticsId, catalogue } = require('../analytics/hireSolidarityCardAnalytics');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

let generateAmounts = (amounts, currency) => amounts.map(amount => ({
    value: amount === 'INFINITE' ? 99999999 : amount,
    label: amount === 'INFINITE' ? formatText('ngoAmounts-maxLimit') : getFormattedString({ amount, currency })
}));

export class HireSelectAccount extends Component {

    constructor(props) {
        super(props);

        this.charityAmountsMin = generateAmounts([0, 5, 10, 20, 30, 40, 50], 'EUR');
        this.charityAmountsMax = generateAmounts(['INFINITE', 3, 5, 10, 20, 40, 60, 80, 100], 'EUR');
        this.charityAmountsMaxOptions = this.charityAmountsMax;

        if (props.stepData && props.stepData.get('minAmount')) {
            this.changeSelectMaxAmount(props.stepData.get('minAmount'));
        }

        this.state = {
            openModalNGO: false,
            accountId: props.stepData && props.stepData.get('accountId') || '',
            accountIdError: false,
            // minAmount: props.stepData && props.stepData.get('minAmount') || this.charityAmounts[0],
            minAmount: props.stepData && props.stepData.get('minAmount')
                ?
                {
                    value: props.stepData.get('minAmount'),
                    label: getFormattedString({ amount: props.stepData.get('minAmount'), currency: 'EUR' })
                }
                :
                this.charityAmountsMin[0],
            minAmountError: false,
            // maxAmount: props.stepData && props.stepData.get('maxAmount') || this.charityAmounts[0],
            maxAmount: props.stepData && props.stepData.get('maxAmount')
                ?
                {
                    value: props.stepData.get('maxAmount'),
                    label: props.stepData.get('maxAmount') === LIMIT_CHARITY_AMOUNT
                        ?
                        formatText('ngoAmounts-maxLimit')
                        :
                        getFormattedString({ amount: props.stepData.get('maxAmount'), currency: 'EUR' })
                }
                :
                this.charityAmountsMax[0],
            maxAmountError: false,
            charityFoundations: props.stepData && props.stepData.get('charityFoundations').toJS() || [],
            charityFoundationsError: false,
            charityFoundationsSource: [],
            charityFoundationsSourceError: false,
            showSearcher: true
        };
    }

    componentWillMount() {
        const accountsById = this.props.immAccounts.get('byId');
        const accountsIndexes = getCurrentAccounts(this.props.immAccounts.get('byOrder').toJS(), accountsById);
        const baseURL = apiURLBuilder.getURL('solidarity');
        const { originCountry } = this.props;

        const dataOngVersion = {
            header: {
                version: 2
            }
        };

        APIGet(() => { }, `${baseURL}/ngos?solidarityCorner=true&solidarityCard=true&country=${originCountry}`, dataOngVersion)
            .then(response => {
                this.setState({
                    charityFoundationsSource: [...response.map(({
                        uniquename,
                        ngoId,
                        name,
                        iban,
                        description,
                        categories,
                        image,
                        deductible,
                        imagelogo
                    }) => ({
                        uniquename,
                        ngoId,
                        name,
                        iban,
                        description,
                        categories,
                        image,
                        deductible,
                        imagelogo,
                        showNotDeductibleMessage: false,
                    }))]
                },
                    () => {
                        this.changeSummaryInformation()
                    });
            })
            .catch(() => {
                this.setState({
                    charityFoundationsSourceError: true
                })
            });

        if (accountsIndexes.length === 1) {
            this.setState({
                accountId: accountsIndexes[0]
            })
        }
    }

    componentDidMount() {
        const { localSetAssociateAccountSelected, localSetNgoSelected, immAccounts, onSetAsCurrentStep, localSetAllAccountsToInactive, processDetail } = this.props;
        const {charityFoundations , accountId } =this.state;
        if(!accountId){
            localSetAssociateAccountSelected(true)
        }

        if(charityFoundations.length === 0){
            localSetNgoSelected(true);
        }
        onSetAsCurrentStep(this.validate);
        recordPage(catalogue[analyticsId.SOLIDARITY_CARD_STEP_2_VIEW]({ productName: processDetail }));

        const allAccountsInactive = hasAllAccountsInactive(getCurrentAccounts(immAccounts.get('byOrder').toJS(), immAccounts.get('byId')), immAccounts.get('byId'));
        if (allAccountsInactive) {
            localSetAllAccountsToInactive();
        }
    }

    componentWillUnmount() {
        const { error } = this.props;

        this.props.localSetWizardButtonStateByButton('next', {
            loading: false,
            disabled: error
        });
    }

    changeSelectMaxAmount = (amount) => {
        const index = this.charityAmountsMax.filter(function (c) {
            return c.value >= amount;
        });
        this.charityAmountsMaxOptions = index;
    }

    changeSummaryInformation = () => {
        const { accountId, charityFoundations, maxAmount, minAmount } = this.state;
        const currentStep = this.props.currentStep;
        const result = {
            accountId,
            charityFoundations,
            maxAmount: maxAmount.value,
            minAmount: minAmount.value,
            isValid: true
        }

        this.props.localAddStep(result, currentStep);
    }

    handleAccountChange = accountId => {
        this.setState({
            accountId,
            accountIdError: false
        },
            () => {
                this.changeSummaryInformation()
            });
    }

    handleSetAmount = (data, origin) => {
        if (origin === 'min') {
            this.changeSelectMaxAmount(data.value);

            this.setState({
                minAmount: data,
                minAmountError: false,
                maxAmount: this.state.maxAmount.value <= data.value ? this.charityAmountsMaxOptions[1] : this.state.maxAmount
            },
                () => {
                    this.changeSummaryInformation()
                });
        } else {
            this.setState({
                maxAmount: data,
                maxAmountError: false
            },
                () => {
                    this.changeSummaryInformation()
                });
        }
    }

    handleSelectCharityFoundation = (charityFoundation, selectedValue) => {
        const { localSetNgoSelected } = this.props;
        const newCharityFoundationsSource = filterLodash(this.state.charityFoundationsSource, function (foundation) {
            return (foundation.ngoId !== charityFoundation.suggestion.ngoId)
        });

        charityFoundation.suggestion.showNotDeductibleMessage = !charityFoundation.suggestion.deductible;
        recordLink(PROC_ONG_SEARCHER, PROC_ONG_RESULT_CLICK + charityFoundation.suggestion.name, selectedValue);

        if (this.state.charityFoundations.length <= 0 || !Boolean(this.state.charityFoundations.find(cf =>
            cf.suggestion.ngoId === charityFoundation.suggestion.ngoId))) {
            this.setState({
                openModalNGO: false,
                charityFoundations: [...this.state.charityFoundations, charityFoundation],
                charityFoundationsError: false,
                showSearcher: false,
                charityFoundationsSource: newCharityFoundationsSource
            },
                () => {
                    this.changeSummaryInformation()
                    localSetNgoSelected(false);
                });
        }
    }

    handleDeleteCharityFoundation = ngoId => {
        const { localSetNgoSelected } = this.props;
        const {charityFoundations } =this.state;

        const charityDelete = [...this.state.charityFoundations.filter(
            charityFoundation => charityFoundation.suggestion.ngoId === ngoId
        )];

        this.setState({
            charityFoundations: [...this.state.charityFoundations.filter(
                charityFoundation => charityFoundation.suggestion.ngoId !== ngoId
            )],
            charityFoundationsSource: this.state.charityFoundationsSource.concat(charityDelete[0].suggestion),
            charityFoundationsError: false,
            showSearcher: this.state.charityFoundations.length === 1
        },
            () => {
                this.changeSummaryInformation()
                if(charityFoundations.length === 1){
                    localSetNgoSelected(true);
                }
            });
    }

    validate = async () => {

        let error = false;

        if (this.state.minAmount.value < 0) {
            error = true;
            this.setState({
                minAmountError: true
            });
        }

        if (this.state.maxAmount.value < this.state.minAmount.value) {
            error = true;
            this.setState({
                maxAmountError: true
            });
        }

        if (this.state.charityFoundations.length === 0) {
            error = true;
            this.setState({
                charityFoundationsError: true
            });
        }

        if (!this.state.accountId) {
            error = true;
            this.setState({
                accountIdError: true
            });
        }

        if (error) {
            return {
                isValid: false
            };
        }

        return {
            isValid: true,
            accountId: this.state.accountId,
            minAmount: this.state.minAmount.value,
            maxAmount: this.state.maxAmount.value,
            charityFoundations: this.state.charityFoundations
        };
    }

    showSearcher = () => {
        this.setState({
            showSearcher: true
        });
    }

    addMoreSection = () => {
        const { showSearcher, charityFoundations } = this.state;

        if (!showSearcher && charityFoundations.length < 5) {
            return (
                <div className="modify-charity-card-data__add-more-message" onClick={() => this.showSearcher()}>
                    <i className="icon retail-loan-personal-data__icon icon-agregar" />
                    <FormattedText value="modifyCharityCard-addMoreMessage" />
                </div>
            )
        }
    }

    openModalNGO = () => {
        this.setState({
            openModalNGO: true
        });
    }

    changeModalState = (value) => {
        this.setState({
            openModalNGO: value
        });
    }

    renderNoSuggestion = () => {
        return <FormattedText value={'ngoSearcher-noSuggestion'} />
    }

    renderButtonNoSuggestion = () => {
        return <FormattedText value={'ngoModal-buttonModalErrorSuggestion'} />;
    }

    filterAccounts = () => {
        const { immAccounts, localSetAssociateAccountSelected } = this.props;
        const { accountId } =this.state;
        if(accountId){
            localSetAssociateAccountSelected(false)
        }
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
        ];

        const accountsIndexes = immAccounts.get('byOrder').toJS().filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes;
    }

    render() {
        const { immAccounts, immFlagBasedFeatures, localSetWizardButtonStateByButton, stepData } = this.props;
        const { showSearcher, charityFoundationsSource } = this.state;
        const accountsById = immAccounts.get('byId');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const accountsIndexes = getCurrentAccounts(immAccounts.get('byOrder').toJS(), accountsById);
        const addMoreSection = this.addMoreSection();
        const isInactiveAccountsEnabled = immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED);
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';
        let newcharityFoundationsSource = stepData
            ?
            getNotSelectedFoundations(stepData.get('charityFoundations').toJS(), charityFoundationsSource)
            :
            charityFoundationsSource;

        if (this.state.charityFoundationsSourceError) {
            localSetWizardButtonStateByButton('next', {
                loading: false,
                disabled: true
            });
            return (
                <h4>
                    <FormattedText value="cardPeriodicLoads-connectionError" />
                </h4>
            );
        }

        return (
            <Fragment>
                <FormattedText
                    className="contract-view__wizard__title"
                    value="hireCardRevolving-step3Title"
                />
                <DropdownAccounts
                    immAccounts={immAccounts.get('byId')}
                    accountsIndexes={this.filterAccounts()}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    onAccountChange={this.handleAccountChange}
                    currentAccountId={this.state.accountId}
                    error={this.state.accountIdError}
                    errorMsg={<FormattedText value="hireSolidarityCard-selectAccountErrorMessage" />}
                    label={formatText('hireSolidarityCard-selectAccountMessage')}
                    showAvailableBalance={true}
                    enabled={true}
                    initialAccountIndex=""
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    tooltipMsg={tooltipMsgContent}
                    loading={isBlockedAccountsLoading}
                    optionalElement={DisclaimerPersonalInfo()}
                />
                <h4 className="step__subtitle">
                    <FormattedText value="hireSolidarityCard-selectNGOMessage" />
                </h4>
                <div className="hire-select-account__ngo-image-selected-wrapper">
                    {
                        this.state.charityFoundations.map((charityFoundation, index) => {
                            if (charityFoundation && charityFoundation.suggestion && charityFoundation.suggestion.name) {
                                return (
                                    <div key={index.toString()} className="hire-select-account__ngo-image-selected">
                                        <div
                                            onClick={() =>
                                                this.handleDeleteCharityFoundation(charityFoundation.suggestion.ngoId)}
                                            className="hire-select-account__delete-image-selected"
                                        >
                                            <FormattedText
                                                value="configCustomItem-delete"
                                                className="hire-select-account__delete-image-selected-text"
                                            />
                                        </div>
                                        <div>{charityFoundation.suggestion.name}</div>
                                    </div>
                                )
                            }
                            return undefined;
                        })
                    }
                </div>
                {addMoreSection}
                {showSearcher &&
                    <Fragment>
                        <OKAutosuggest
                            dataset={newcharityFoundationsSource}
                            maxItems="5"
                            content="name"
                            widthInput="small"
                            format="text"
                            datasetKey="name"
                            placeholder={formatText('hireSolidarityCard-selectNGOPlaceholderMessage')}
                            noSuggestionComponent={this.renderNoSuggestion()}
                            buttonNoSuggestionComponent={this.renderButtonNoSuggestion()}
                            onSelect={this.handleSelectCharityFoundation}
                            error={this.state.charityFoundationsError}
                            handleOnError={this.openModalNGO}
                            errorMessage={<FormattedText value="hireSolidarityCard-selectNGOErrorMessage" />}
                        />
                        <NGOModalSearcher
                            changeCharityFoundation={this.handleSelectCharityFoundation}
                            typeNGOModal={NGO_MODAL_CARD}
                            openModal={this.state.openModalNGO}
                            closeModal={this.changeModalState}
                            charityFoundations={newcharityFoundationsSource}
                        />
                    </Fragment>
                }
                <h4 className="step__subtitle">
                    <FormattedText value="hireSolidarityCard-setCardLimitsMessage" />
                </h4>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <OKSelect
                            clearable={false}
                            label={formatText('hireSolidarityCard-minimumAmountMessage')}
                            matchPos="start"
                            matchProp="label"
                            disabled={false}
                            searchable={false}
                            options={
                                this.charityAmountsMin.slice(0, this.charityAmountsMin.length - 1)
                            }
                            onChange={data => this.handleSetAmount(data, 'min')}
                            value={this.state.minAmount}
                            errorState={this.state.minAmountError}
                            errorMessage={<FormattedText value="hireSolidarityCard-minimumAmountErrorMessage" />}
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <OKSelect
                            clearable={false}
                            label={formatText('hireSolidarityCard-maximumAmountMessage')}
                            matchPos="start"
                            matchProp="label"
                            disabled={false}
                            searchable={false}
                            options={this.charityAmountsMaxOptions}
                            onChange={data => this.handleSetAmount(data, 'max')}
                            value={this.state.maxAmount}
                            errorState={this.state.maxAmountError}
                            errorMessage={<FormattedText value="hireSolidarityCard-maximumAmountErrorMessage" />}
                        />
                    </div>
                </div>
                <ContractDisclaimerPersonalInfo
                    linkTextKey="accountDirectDebitLinkText"
                    linkUrlKey="accountDirectDebitLinkUrl"
                    messageKey="solidarityAccount"
                />
            </Fragment>
        );
    }
}

HireSelectAccount.propTypes = {
    message: PropTypes.string.isRequired,
    onSetAsCurrentStep: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    stepData: PropTypes.object,
    currentStep: PropTypes.number,
    localSetWizardButtonStateByButton: PropTypes.func.isRequired,
    localAddStep: PropTypes.func,
    localSetAllAccountsToInactive: PropTypes.func.isRequired,
    error: PropTypes.bool,
    originCountry: PropTypes.string,
    isNgoNotSelected: PropTypes.bool,
    processDetail: PropTypes.string,
}

module.exports.HireSelectAccount = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        currentStep: state.okWizard.get('currentStep'),
        error: state.okWizard.get('error'),
        isNgoNotSelected: state.okWizard.get('isNgoNotSelected')
    }),
    {
        localAddStep: addStep,
        localSetAllAccountsToInactive: setAllAccountsToInactive,
        localSetWizardButtonStateByButton: setWizardButtonStateByButton,
        localSetNgoSelected: setNgoSelected,
        localSetAssociateAccountSelected: setAssociateAccountSelected,
    }
)(HireSelectAccount);
